import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import type { Workout } from '../../api/workout-service';

export type WorkoutResumeCardProps = {
    workout: Workout;
    cover: string;
};

/** The workout the user left unfinished, with how far they got and how many lives remain. */
export function WorkoutResumeCard({ workout, cover }: WorkoutResumeCardProps) {
    const me = workout.currentUser;
    const total = workout.questions.length;
    const answered = workout.questions.filter((question) => question.answers.some((answer) => answer.user === me?.id)).length;
    // The backend counts lives only once the first question is answered
    const lives = me?.lives;

    return (
        <Stack component="section" aria-label="Resume" direction={ { xs: 'column', sm: 'row' } } alignItems={ { sm: 'center' } } spacing={ 2.5 }
               sx={ { bgcolor: '#FFFFFF', border: '1px solid #E3E8EE', borderRadius: '16px', p: 1.75 } }>
            <Box component="img" src={ cover } alt="" sx={ { width: 132, height: 99, objectFit: 'cover', borderRadius: '10px', flexShrink: 0 } }/>

            <Stack spacing={ 0.75 } sx={ { flexGrow: 1, minWidth: 0 } }>
                <Typography sx={ { fontSize: 12, fontWeight: 700, color: '#1A55B3', letterSpacing: '0.06em', textTransform: 'uppercase' } }>
                    Continue
                </Typography>
                <Typography sx={ { fontSize: 18, fontWeight: 700 } }>{ workout.workoutTitle }</Typography>
                <Stack direction="row" alignItems="center" flexWrap="wrap" gap={ 1.75 } sx={ { fontSize: 13, color: '#4F5B67' } }>
                    <span>Question { Math.min(answered + 1, total) } of { total }</span>
                    <Stack direction="row" spacing={ 0.5 } aria-label={ `Progress: ${ answered } answered of ${ total }` } role="img">
                        { workout.questions.map((question, index) => (
                            <Box key={ question.id } sx={ { width: 28, height: 6, borderRadius: '3px', bgcolor: index < answered ? '#2065D1' : '#CFD6DE' } }/>
                        )) }
                    </Stack>
                    { lives != null && <span>{ lives } { lives === 1 ? 'life' : 'lives' } left</span> }
                </Stack>
            </Stack>

            <Button component={ RouterLink } to={ `/workouts/${ workout.id }` } variant="contained" size="large"
                    sx={ { borderRadius: '10px', fontWeight: 700, px: 2.75, flexShrink: 0 } }>
                Resume
            </Button>
        </Stack>
    );
}
